var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpandContent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1777_2022",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1777_2022)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.99988 14H6.99988C7.28321 14 7.52071 14.0958 7.71238 14.2875C7.90404 14.4792 7.99988 14.7167 7.99988 15C7.99988 15.2833 7.90404 15.5208 7.71238 15.7125C7.52071 15.9042 7.28321 16 6.99988 16H2.99988C2.71654 16 2.47904 15.9042 2.28738 15.7125C2.09571 15.5208 1.99988 15.2833 1.99988 15V11C1.99988 10.7167 2.09571 10.4792 2.28738 10.2875C2.47904 10.0958 2.71654 10 2.99988 10C3.28321 10 3.52071 10.0958 3.71238 10.2875C3.90404 10.4792 3.99988 10.7167 3.99988 11V14ZM13.9999 4H10.9999C10.7165 4 10.479 3.90417 10.2874 3.7125C10.0957 3.52083 9.99988 3.28333 9.99988 3C9.99988 2.71667 10.0957 2.47917 10.2874 2.2875C10.479 2.09583 10.7165 2 10.9999 2H14.9999C15.2832 2 15.5207 2.09583 15.7124 2.2875C15.904 2.47917 15.9999 2.71667 15.9999 3V7C15.9999 7.28333 15.904 7.52083 15.7124 7.7125C15.5207 7.90417 15.2832 8 14.9999 8C14.7165 8 14.479 7.90417 14.2874 7.7125C14.0957 7.52083 13.9999 7.28333 13.9999 7V4Z",
    fill: "#357EFF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandContent);
export default __webpack_public_path__ + "static/media/expand_content.24d3c76fbbf05ebd87d11764e8ccef65.svg";
export { ForwardRef as ReactComponent };